export const _FULL_OR_PARTIME = {
};

_FULL_OR_PARTIME.OPTIONS = [
    { code: 'fulltime', text: 'Full time' },
    { code: 'parttime', text: 'Part time' }
];
